import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from 'Components/Organisms/UserProvider/useUser';
import { ROUTES } from 'Utils/constants';

export default function GuardPublic() {
    const { user } = useUser();

    if (user) {
        return <Navigate to={ROUTES.dashboards} />;
    }

    return <Outlet />;
}
